import { createIntl, createIntlCache } from 'react-intl';

export default createIntl(
  {
    locale: 'en',
  },
  createIntlCache(),
);
